import GuideApi from './rest/GuideApi';

export default new GuideApi();
